import { allowedStyleProperties } from '../config/html-sanitize';

const forbiddenValuePattern = /url\s*\(|expression\s*\(|[\\<>]/i;

export default function sanitizeStyle(style: string): string {
    return style
        .split(';')
        .map((declaration) => {
            const separatorIndex = declaration.indexOf(':');
            if (separatorIndex === -1) return null;

            const property = declaration.slice(0, separatorIndex).trim().toLowerCase();
            const value = declaration.slice(separatorIndex + 1).trim();

            if (!allowedStyleProperties.includes(property)) return null;
            if (!value || forbiddenValuePattern.test(value)) return null;

            return `${property}:${value}`;
        })
        .filter(Boolean)
        .join(';');
}
